import React from 'react';

/**
 * TermsPage component
 * Terms of Service page for the healthcare AI platform
 */
const TermsPage = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="py-20" style={{
        background: `linear-gradient(to top, #FFC000 0%, #FFFFFF 3%, #FFFFFF 97%, #FFC000 100%)`
      }}>
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 text-gray-900">
              Terms of <span style={{ color: '#FFC000' }}>Service</span>
            </h1>
            
            <p className="text-xl md:text-2xl mb-8 text-gray-700">
              Please read these terms carefully before using our platform.
            </p>
            
            <p className="text-gray-600">
              Last updated: January 2025
            </p>
          </div>
        </div>
      </section>

      {/* Terms Content */}
      <section className="py-16 bg-white dark:bg-gray-800">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto prose prose-lg dark:prose-invert">
            
            <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">Acceptance of Terms</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              By accessing and using the Videxa healthcare AI platform, you accept and agree to be bound by the terms and provision of this agreement.
            </p>

            <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">Service Description</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              Videxa provides AI-powered healthcare solutions including claims processing, revenue cycle management, and clinical decision support tools designed to improve healthcare operations and outcomes.
            </p>

            <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">User Responsibilities</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              As a user of our platform, you agree to:
            </p>
            <ul className="list-disc list-inside text-gray-600 dark:text-gray-300 mb-6 space-y-2">
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Use the platform in compliance with applicable laws and regulations</li>
              <li>Respect intellectual property rights</li>
              <li>Not attempt to disrupt or compromise platform security</li>
            </ul>

            <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">Healthcare Compliance</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              Our platform is designed to support HIPAA compliance and other healthcare regulations. Users are responsible for ensuring their use of the platform complies with all applicable healthcare laws and organizational policies.
            </p>

            <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">Intellectual Property</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              All content, features, and functionality of the Videxa platform are owned by us and are protected by copyright, trademark, and other intellectual property laws.
            </p>

            <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">Limitation of Liability</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              Videxa shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the platform. Our total liability shall not exceed the amount paid for the services.
            </p>

            <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">Service Availability</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              We strive to maintain high service availability but do not guarantee uninterrupted access. Scheduled maintenance and unexpected outages may occur.
            </p>

            <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">Termination</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              Either party may terminate the service agreement with appropriate notice. Upon termination, access to the platform will be discontinued and data export options will be provided.
            </p>

            <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">Contact Information</h2>
            <div className="bg-gray-50 dark:bg-gray-700 p-6 rounded-lg">
              <p className="text-gray-600 dark:text-gray-300">
                For questions about these Terms of Service, contact us at:<br />
                <strong>Email:</strong> legal@videxa.com<br />
                <strong>Phone:</strong> 1-888-465-4246<br />
                <strong>Address:</strong> 123 Healthcare Innovation Drive, San Francisco, CA 94105
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;